import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../../components/ui/Button';
import Input from '../../../../components/ui/Input';
import { Checkbox } from '../../../../components/ui/Checkbox';
import Icon from '../../../../components/AppIcon';
import {login, resetPassword} from '../../../../services/accountService';
import { useDispatch } from 'react-redux';
import { loginUser } from 'redux/reducers/authSlice';
import { toast } from 'react-toastify';

const LoginForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    rememberMe: false
  });
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [forgotPassword, setForgotPassword] = useState(false);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e?.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    
    // Clear error when user starts typing
    if (errors?.[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData?.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/?.test(formData?.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if(!forgotPassword){
      if (!formData?.password) {
        newErrors.password = 'Password is required';
      } else if (formData?.password?.length < 6) {
        newErrors.password = 'Password must be at least 6 characters';
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors)?.length === 0;
  };

  const loginHandler = async ()=>{
    try{
      const response = await login(formData?.email, formData?.password);

      if(response && response.success){
        //Check if rememberMe is checked and store token in localStorage
        // if(formData?.rememberMe){
        //   localStorage.setItem('rememberMeEmail', formData?.email);
        // }
        const {data, message} = response;
        localStorage.setItem('authToken', data?.token);
        localStorage.setItem('userProfile', JSON.stringify({
          name: data?.name,
          surname: data?.surname,
          displayName:  data?.displayName,
          email: data?.email,
          loginTime: new Date()?.toISOString(),
          contactNo: data?.contactNo,
        }));

        //Dispatch to Redux
        dispatch(loginUser(data));

        if (formData?.rememberMe) {
          localStorage.setItem('rememberMe', 'true');
        }
        setIsLoading(false);
        // Redirect to dashboard
        navigate('/admin-dashboard');
      }
      else{
        setIsLoading(false);
        setErrors({
          submit: 'Login failed. Please try again.'
        });
      }
    }
    catch(err){
      setIsLoading(false);
      setErrors({
        submit: 'Invalid email or password.'
      });
    }
  }

  const forgotPasswordHandler = async () => {
    
    const response = await resetPassword(formData?.email);
    if(response && response.success){
      toast.success(response?.message || 'Reset link sent to your email.')
    }
    else{
      toast.error(response?.message || 'Failed to send reset link. Please try again.')
    }
    
    setIsLoading(false);
  }

  const handleSubmit = async (e) => {
    e?.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsLoading(true);

    if(forgotPassword){
      console.log('Forgot Password Logic');
      await forgotPasswordHandler();
    }
    else{
      await loginHandler();
    }
    

  };

  const getSubmitButtonText = () =>{
    if(forgotPassword){
      return isLoading ? 'Sending Reset Link...' : 'Send Reset Link';
    }
    else{
      return isLoading ? 'Signing In...' : 'Sign In';
    }
  }


  return (
    <div className="w-full max-w-md mx-auto">
      <form onSubmit={handleSubmit} className="space-y-5">
        {/* Email Input */}
        <Input
          label="Email Address"
          type="email"
          name="email"
          placeholder="Enter your email"
          value={formData?.email}
          onChange={handleInputChange}
          error={errors?.email}
          required
          disabled={isLoading}
          className="w-full"
        />

        {/* Password Input */}
        {!forgotPassword &&<Input
          label="Password"
          type="password"
          name="password"
          placeholder="Enter your password"
          value={formData?.password}
          onChange={handleInputChange}
          error={errors?.password}
          required
          disabled={isLoading}
          className="w-full"
        />}

        {/* Remember Me Checkbox */}
        <div className="flex items-center justify-center">
          {/* <Checkbox
            label="Remember me"
            name="rememberMe"
            checked={formData?.rememberMe}
            onChange={handleInputChange}
            disabled={isLoading}
            size="sm"
          /> */}
          
          <Button
            variant="link"
            size="sm"
            onClick={() => setForgotPassword(!forgotPassword)}
            disabled={isLoading}
            className="text-primary hover:text-primary/80 p-0 h-auto"
            type="button"
          >
            {forgotPassword ? 'Back to Login' : 'Forgot Password?'}
          </Button>
        </div>

        {/* Submit Error */}
        {errors?.submit && (
          <div className="p-3 bg-destructive/10 border border-destructive/20 rounded-lg">
            <div className="flex items-center space-x-2">
              <Icon name="AlertCircle" size={16} className="text-destructive" />
              <span className="text-sm text-destructive">{errors?.submit}</span>
            </div>
          </div>
        )}

        {/* Sign In Button */}
        <Button
          type="submit"
          variant="default"
          size="lg"
          loading={isLoading}
          disabled={isLoading}
          iconName={isLoading ? undefined : "LogIn"}
          iconPosition="left"
          iconSize={18}
          className="w-full"
        >
          {getSubmitButtonText()}
        </Button>
      </form>
    </div>
  );
};

export default LoginForm;